<template>
	<div class="c-news-index">
		<loading-dots v-if="loading"></loading-dots>
		<div class="o-grid" v-if="!loading">
			<div class="o-grid__item h-offset-left--one-sixth h-two-thirds h-offset-right--one-sixth h-phone-one-whole h-phone-offset-left--none h-phone-offset-right--none h-margin-bottom--half" v-for="(item, index) in items" :key="item.id">
				<v-card :item="item">
				</v-card>
				<slot :name="'injected-content-' + index"></slot>
			</div>
			<div class="o-grid__item h-offset-left--one-sixth h-two-thirds h-offset-right--one-sixth h-phone-one-whole h-phone-offset-left--none h-phone-offset-right--none">
				<vPagination :items="pagination" @paginate="getItems"></vPagination>
			</div>
		</div>
	</div>
</template>


<script>
	import vCard from './card.vue';
	import vPagination from './pagination.vue';
	import loadingDots from './loading-dots.vue';
	import axios from 'axios';

	export default {
		name: 'news-index',
		data() {
			return {
				loading    : true,
				items      : [],
				pagination : {}
			}
		},
		components : {
			vCard,
			vPagination,
			loadingDots
		},
		mounted() {
			if (this.active) {

				var match,
		        pl     = /\+/g,  // Regex for replacing addition symbol with a space
		        search = /([^&=]+)=?([^&]*)/g,
		        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
		        query  = window.location.hash.split('?')[1];

		    var urlParams = {};
		    while (match = search.exec(query))
		       urlParams[decode(match[1])] = decode(match[2]);

				if (urlParams.page) {
					this.getItems(urlParams.page);
				}
				this.getItems();
			}
		},
		props: {
			id: {
				type: Number
			},
			after: {
				type: String,
				default: ''
			},
			active: {
				type: Boolean
			}
		},
		methods: {
			getItems(n) {
				var apiUrl = '/api/news.json?'

				if (this.id) {
					var apiUrl = apiUrl + 'relatedTo=' + this.id
				}

				if (n) {
					var apiUrl = apiUrl + '&page=' + n;
					this.$root.updateQueryString('page', n);
					this.$scrollTo('.c-news-index');
				}

				if (this.after) {
					var apiUrl = apiUrl + '&after=' + this.after;
				}

				axios.get(apiUrl, { crossdomain: true })
				.then((response) => {
						this.items       = response.data.data;
						this.pagination  = response.data.meta.pagination;
						this.loading     = false;
				})
			},
		},
		watch: {
			active: function(newVal, oldVal) {
				if (!this.items.length) {
					this.getItems();
				}
			}
		}
	};
</script>



// WEBPACK FOOTER //
// news-index.vue?6321aa15